import { InfoOutline } from '@mui/icons-material'
import { useEffect, useMemo } from 'react'
import ReactGA from 'react-ga4'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { selectFrontendSettings } from 'store/selectors/frontendSettings'
import { selectIsLibraryMode } from 'store/selectors/user'
import { getSessionActiveVersion } from 'utils/ab_testing'
import { renderRichText } from 'utils/helpers'

const AB_KEY = 'community-conversion-cta'
const AB_CHOICES = ['A', 'B']
const AB_PROMOTIONS = {
  A: {
    id: 'premium',
    name: 'Premium'
  },
  B: {
    id: 'webinar',
    name: 'Webinar'
  }
}

const ConversionCTABanner = () => {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)

  const version = useMemo(() => getSessionActiveVersion(AB_KEY, AB_CHOICES))

  const promotion = AB_PROMOTIONS[version]
  const promotionDetails = {
    promotion_id: `community_edition_cta_${promotion.id}`,
    promotion_name: `Community Edition CTA Banner (${promotion.name}`
  }

  useEffect(() => {
    ReactGA.event('view_promotion', promotionDetails)
  }, [])

  const onClick = event => {
    // User clicked on anchor element
    if (event.target.href) {
      ReactGA.event('select_promotion', promotionDetails)
    }
  }

  return (
    <div className="community-edition-conversion-cta">
      <InfoOutline />
      <span onClick={onClick} onAuxClick={onClick}>
        {renderRichText(t.search.banner.conversionCTA[`option${version}`])}
      </span>
    </div>
  )
}

const SearchBanner = () => {
  const settings = useSelector(selectFrontendSettings)
  const isLibraryMode = useSelector(selectIsLibraryMode)

  return (
    <div className="search-banner">
      {isLibraryMode && settings.enableCeCtaBanner && <ConversionCTABanner />}
    </div>
  )
}

export default SearchBanner
